module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1217.aecb4207.png";